import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { APP_LOGIN_URL, buildSignupUrl } from "@/lib/constants";
import { trackEvent } from "@/lib/analytics";
// RESONATE_ANALYTICS_INSTRUMENTED

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    trackEvent('nav_link_click', { target: id });
    if (window.location.pathname !== "/") {
      window.location.href = `/#${id}`;
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="nav-bar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[rgba(250,250,255,0.85)] backdrop-blur-xl border-b border-[#E5E7EB]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 flex items-center justify-between h-[72px]">
        <a href="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <img
            src="/brand/logo.png"
            alt="Resonate logo"
            width="28"
            height="27"
            decoding="async"
            className="h-7 w-7 object-contain transition-transform group-hover:rotate-3"
            draggable="false"
          />
          <span style={{ fontFamily: "var(--f-serif)" }} className="text-[19px] tracking-tight text-[#111827]">Resonate</span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {[
            ["Features", "features"],
            ["Pricing", "pricing"],
            ["FAQ", "faq"],
          ].map(([label, id]) => (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              data-testid={`nav-link-${id}`}
              className="text-[13.5px] text-[rgba(17,24,39,0.6)] hover:text-[#261F49] px-4 py-2 rounded-md transition-colors"
            >
              {label}
            </button>
          ))}
          {/* RESONATE_AGENCIES_V2 */}
          <a
            href="/agencies"
            onClick={() => trackEvent('nav_link_click', { target: 'agencies' })}
            data-testid="nav-link-agencies"
            className="text-[13.5px] text-[rgba(17,24,39,0.6)] hover:text-[#261F49] px-4 py-2 rounded-md transition-colors"
          >
            Agencies
          </a>
          <a
            href="/blog"
            data-testid="nav-link-blog"
            className="text-[13.5px] text-[rgba(17,24,39,0.6)] hover:text-[#261F49] px-4 py-2 rounded-md transition-colors"
          >
            Blog
          </a>
        </div>

        <div className="flex items-center gap-2">
          <a
            href={APP_LOGIN_URL} onClick={() => trackEvent('cta_click', { location: 'nav' })}
            data-testid="nav-signin-btn"
            className="hidden sm:inline-flex text-[13.5px] text-[rgba(17,24,39,0.6)] hover:text-[#261F49] px-4 py-2 rounded-md transition-colors"
          >
            Sign in
          </a>
          <a
            href={buildSignupUrl('nav')} onClick={() => trackEvent('cta_click', { location: 'nav' })}
            data-testid="nav-cta-btn"
            aria-label="Start for free (top nav)"
            className="inline-flex items-center gap-1.5 text-[13.5px] text-white bg-[#111827] hover:bg-[#261F49] px-4 py-2.5 rounded-lg font-medium transition-colors"
          >
            Start for free <ArrowRight className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </nav>
  );
};
